import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { Checklist } from '#models';

@Injectable({
  providedIn: 'root',
})
export class ChecklistService {
  httpClient = inject(HttpClient);

  // switchSectionOrder(item1: Pick<Section, 'id' | 'sortId'>, item2: Pick<Section, 'id' | 'sortId'>) {
  //   return this.httpClient.put(`${environment.apiUrl}/sections`, {
  //     item1,
  //     item2,
  //   });
  // }

  // getChecklistDetails(checklistId: number): Observable<Checklist> {
  //   return this.httpClient.get<Checklist>(`${environment.apiUrl}/checklists/${checklistId}/details`);
  // }

  // createChecklistSection(checklistId: number, section: ChecklistSection): Observable<ChecklistSection> {
  //   return this.httpClient.post<ChecklistSection>(`${environment.apiUrl}/checklists/${checklistId}/sections`, section);
  // }

  getChecklistsByBusinessId(buId: number): Observable<Checklist[]> {
    return this.httpClient.get<Checklist[]>(`${environment.apiUrl}/checklists?businessUnitId=${buId.toString()}`);
  }

  // public createChecklist(checklistData: ChecklistInput): Observable<Checklist> {
  //   return this.httpClient.post<Checklist>(`${environment.apiUrl}/checklists`, checklistData);
  // }

  // public getChecklistById(checklistId: number): Observable<Checklist> {
  //   return this.httpClient.get<Checklist>(`${environment.apiUrl}/checklists/${checklistId}`);
  // }

  // public editChecklist(checklistId: number, checklistData: ChecklistInput): Observable<Checklist> {
  //   return this.httpClient.put<Checklist>(`${environment.apiUrl}/checklists/${checklistId}`, checklistData);
  // }

  // deleteChecklist(checklistId: number) {
  //   return this.httpClient.delete<void>(`${environment.apiUrl}/checklists/${checklistId}`);
  // }

  // getLookUpList(): Observable<string[]> {
  //   return this.httpClient.get<string[]>(`${environment.apiUrl}/checklists/lookup`);
  // }

  // importChecklist(checkListImport: ChecklistLookup): Observable<Checklist> {
  //   return this.httpClient.post<Checklist>(`${environment.apiUrl}/checklists/import`, checkListImport);
  // }

  // editChecklistSection(sectionId: number, section: ChecklistSection): Observable<ChecklistSection> {
  //   return this.httpClient.put<ChecklistSection>(`${environment.apiUrl}/sections/${sectionId}`, section);
  // }

  // deleteChecklistSection(sectionId: number): Observable<ChecklistSection> {
  //   return this.httpClient.delete<ChecklistSection>(`${environment.apiUrl}/sections/${sectionId}`);
  // }

  // createChecklistSubSection(sectionId: number, subsection: ChecklistSubSection): Observable<ChecklistSubSection> {
  //   return this.httpClient.post<ChecklistSubSection>(
  //     `${environment.apiUrl}/sections/${sectionId}/subsections`,
  //     subsection
  //   );
  // }

  // editChecklistSubSection(subsectionId: number, subsection: ChecklistSubSection): Observable<ChecklistSubSection> {
  //   return this.httpClient.put<ChecklistSubSection>(`${environment.apiUrl}/subsections/${subsectionId}`, subsection);
  // }

  // addChecklistItemToSubSection(subSectionId: number, item: ChecklistItemCreateUpdate): Observable<ChecklistItem> {
  //   return this.httpClient.post<ChecklistItem>(
  //     `${environment.apiUrl}/subsections/${subSectionId}/checklist-items`,
  //     item
  //   );
  // }

  // deleteChecklistItemById(checklistItemId: number) {
  //   return this.httpClient.delete(`${environment.apiUrl}/checklist-items/${checklistItemId}`, {
  //     observe: 'response',
  //   });
  // }

  // deleteChecklistSubSection(subsectionId: number): Observable<ChecklistSubSection> {
  //   return this.httpClient.delete<ChecklistSubSection>(`${environment.apiUrl}/subsections/${subsectionId}`);
  // }

  // editChecklistItemById(checklistItemId: number, item: ChecklistItemCreateUpdate): Observable<ChecklistItem> {
  //   return this.httpClient.put<ChecklistItem>(`${environment.apiUrl}/checklist-items/${checklistItemId}`, item);
  // }

  // switchChecklistItemOrder(item1: Pick<Section, 'id' | 'sortId'>, item2: Pick<Section, 'id' | 'sortId'>) {
  //   return this.httpClient.put(`${environment.apiUrl}/checklist-items`, {
  //     item1,
  //     item2,
  //   });
  // }

  // switchSubSectionOrder(item1: Pick<Section, 'id' | 'sortId'>, item2: Pick<Section, 'id' | 'sortId'>) {
  //   return this.httpClient.put(`${environment.apiUrl}/subsections`, {
  //     item1,
  //     item2,
  //   });
  // }
}
